export const BASE_URL = "https://api.stunnerave.com";
